export type {
  GetConversationsResponse as PaginatedConversationsResponse,
  GetConversationByIdResponse,
  GetMessagesResponse,
  ConversationObject as Conversation,
  ConversationUser,
  ConversationProduct,
} from './aliases';

// A chat message as returned by presentation-api, plus the client-only
// `isSending` flag set on optimistically-rendered messages.
export type Message = {
  id: string;
  user_id: number;
  text: string;
  created_timestamp: number;
  isSending?: boolean;
};

export type SendMessageRequest = {
  userId: number;
  text: string;
  productId?: number;
  token?: string;
};

export type MessageCachePartialType = {
  pages: [{ data: { objects: Message[] } }];
};

export enum ChatMetaStatus {
  UserBanned = 'USER_BANNED',
  SellerAndProductBanned = 'SELLER_AND_PRODUCT_BANNED',
  BuyerAndProductBanned = 'BUYER_AND_PRODUCT_BANNED',
  BuyerBannedAndProductDeleted = 'BUYER_BANNED_AND_PRODUCT_DELETED',
  ProductBanned = 'PRODUCT_BANNED',
  ProductDeleted = 'PRODUCT_DELETED',
  BuyerBanned = 'BUYER_BANNED',
  DepopOfficial = 'DEPOP_OFFICIAL',
}
